// @flow

import { mClient } from '../net/clientFactory'
import * as browserEnv from './browserEnv'
import { wxShare } from '../ui/popup'
import {
  showShareButton,
  share,
  hiddenShareButton as nativeHiddenShareButton
} from './app/all'
import { shareWeixinApp } from './app/weixin'
import * as analysis from './analysis'
import wx from '@caofeilong/weixin_js'
import { getState } from 'redux/store'

var weixinJsConfig
var errorCount = 0

type ShareInfo = {
  title: string,
  imgUrl: string,
  desc: string,
  link: string,
  miniShareImgUrl?: string,
  failure?: () => void,
  success?: () => void
};

function shareAnalytics (activityInfo) {
  if (
    !activityInfo ||
    !activityInfo.shareCategory ||
    !activityInfo.category ||
    !activityInfo.activityName
  ) {
    return
  }
  if (getState().vars.visitor && getState().vars.visitor.isLogin) {
    return mClient.postJson('/v2/common/backendPostRequireLogin', {
      path: '/loanoperation/api/v3/share/shareCallBack/MYSELF',
      query: {
        version: '1.0'
      },
      form: activityInfo
    })
  } else {
    return mClient.postJson('/v2/common/backendPost', {
      path: '/loanoperation/api/v3/share/shareCallBackNoLogin',
      query: {
        version: '1.0'
      },
      form: activityInfo
    })
  }
}

function formatShareStr (obj, str) {
  if (obj && str) {
    str = str.replace(/\$\{([0-9A-Za-z-_]*)\}/g, function ($1, $2) {
      return obj[$2] || ''
    })
  }
  return str
}

function initWeixinShare (shareInfo: ShareInfo) {
  if (!browserEnv.isInWeixin()) {
    return
  }
  let opts = { ...shareInfo }
  if (opts.imgUrl) {
    opts.imgUrl = opts.imgUrl.replace(/^\/\//, 'http://')
  }
  setTimeout(function () {
    wxConfigReady().then(function () {
      let oriSuccess = opts.success
      let cancel = opts.failure
      opts.success = function () {
        wxShare.close()
        if (oriSuccess) {
          oriSuccess()
        }
        shareAnalytics(opts)
        analysis.trackEventValue('weixin-share-success', {
          url: opts.link
        })
      }
      opts.cancel = function () {
        wxShare.close()
        cancel && cancel instanceof Function && cancel()
        analysis.trackEventValue('weixin-share-cancel', {
          url: opts.link
        })
      }
      delete opts.failure
      wx.ready(function () {
        wx.onMenuShareTimeline(opts)
        wx.onMenuShareAppMessage(opts)
        wx.onMenuShareQQ(opts)
      })
      wx.error(function (res) {
        if (res.errMsg === 'config:invalid signature') {
          errorCount++
          if (errorCount <= 100) {
            getState().vars.landingUrl = window.location.href
            weixinJsConfig = null
            initWeixinShare(opts)
          }
        }
      })
    })
  }, 100)
}

function wxConfigReady () {
  return getWeixinJsConfig().then(function (config) {
    var jsApis = [
      'onMenuShareTimeline',
      'onMenuShareAppMessage',
      'onMenuShareQQ',
      'hideAllNonBaseMenuItem',
      'showAllNonBaseMenuItem',
      'previewImage',
      'chooseImage'
    ]
    var wxConfig = {
      debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId: config.appId, // 必填，公众号的唯一标识
      timestamp: config.timestamp, // 必填，生成签名的时间戳
      nonceStr: config.nonceStr, // 必填，生成签名的随机串
      signature: config.signature, // 必填，签名，见附录1
      jsApiList: jsApis // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
    }
    wx.config(wxConfig)
  })
}

function getWeixinJsConfig () {
  if (weixinJsConfig) {
    return Promise.resolve(weixinJsConfig)
  }
  return mClient
    .get('/v2/weixin/jsConfig', {
      pageUrl: getUrlWithoutHash()
    })
    .then(function (jsConfig) {
      weixinJsConfig = jsConfig
      return jsConfig
    })
}

function getUrlWithoutHash () {
  var url = window.location.href
  if (getState().vars && getState().vars.landingUrl) {
    url = getState().vars.landingUrl
  }
  if (url.indexOf('#') === -1) {
    return url
  }
  return url.substring(0, url.indexOf('#'))
}

function shareByCode (
  opt: string | { code: string, data: any, hidenAppShareBtn: boolean },
  data: any,
  success: () => void,
  cancel: () => void
): { popup: () => void } {
  let code: string = ''
  let hidenAppShareBtn = false
  if (opt instanceof Object) {
    code = opt.code
    data = opt.data
    hidenAppShareBtn = opt.hidenAppShareBtn
    success = opt.success
    cancel = opt.cancel
  }
  if (typeof opt === 'string') {
    code = opt
  }

  let shareInfo = {}
  let sharePromise = mClient
    .get('/cms/public/shareInfo', { code })
    .then(
      (cmsShareInfo: {
        imgUrl: string,
        title: string,
        desc: string,
        link: string
      }) => {
        shareInfo = { ...cmsShareInfo }
        shareInfo.title = formatShareStr(data, shareInfo.title)
        shareInfo.desc = formatShareStr(data, shareInfo.desc)
        let link = shareInfo.link
        shareInfo.link = formatShareStr(
          data,
          /^\/.*$/.test(link) ? window.location.origin + link : link
        )
        if (success) {
          shareInfo.success = success
        }
        if (cancel) {
          shareInfo.failure = cancel
        }
        initShareInfo(shareInfo, hidenAppShareBtn)
        return shareInfo
      }
    )
  return {
    popup: function () {
      sharePromise.then(showShareAlert)
    }
  }
}

function initShareInfo (shareInfo: ShareInfo, hidenAppShareBtn?: boolean) {
  const { title, link, miniShareImgUrl, imgUrl } = shareInfo
  if (
    browserEnv.isInFjApp() ||
    browserEnv.isInYddApp() ||
    browserEnv.isInLcsApp() ||
    browserEnv.isInXqkdApp()
  ) {
    if (!hidenAppShareBtn) {
      showShareButton(getShareInfo(shareInfo))
    }
  } else if (browserEnv.isInWeixinApp()) {
    shareWeixinApp({
      title,
      path: link,
      imageUrl: miniShareImgUrl || imgUrl
    })
  } else {
    initWeixinShare(shareInfo)
  }
}

function getShareInfo (shareInfo) {
  let newShareInfo = { ...shareInfo }
  const { miniShareImgUrl, userName, link } = newShareInfo
  if (miniShareImgUrl) {
    newShareInfo.miniProgramImage = miniShareImgUrl
    delete newShareInfo.miniShareImgUrl
    if (/^\/pages\//.test(link)) {
      newShareInfo.path = link
    } else {
      if (userName === 'gh_93f657211f55') {
        newShareInfo.path = `/pages/pageIn/index?src=${encodeURIComponent(
          link
        )}`
      }
      if (userName === 'gh_9d05af55a806') {
        newShareInfo.path = `/pages/web/index?src=${encodeURIComponent(link)}`
      }
    }
  } else {
    delete newShareInfo.userName
    delete newShareInfo.miniShareImgUrl
  }
  return newShareInfo
}

function showShareAlert (shareInfo: ShareInfo) {
  if (
    browserEnv.isInFjApp() ||
    browserEnv.isInYddApp() ||
    browserEnv.isInLcsApp() ||
    browserEnv.isInXqkdApp()
  ) {
    share(getShareInfo(shareInfo))
  } else if (browserEnv.isInWeixinApp()) {
    const { title, link, miniShareImgUrl, imgUrl } = shareInfo
    shareWeixinApp({
      title,
      path: link,
      imageUrl: miniShareImgUrl || imgUrl
    })
  } else {
    wxShare().then(function () {
      let cancel = shareInfo.failure
      cancel && cancel instanceof Function && cancel()
      analysis.trackEventValue('weixin-share-cancel', {
        url: shareInfo.link
      })
    })
  }
}

function hiddenShareButton () {
  if (browserEnv.isInApp()) {
    nativeHiddenShareButton()
  }
}

export { shareByCode, initShareInfo, showShareAlert, hiddenShareButton }



// WEBPACK FOOTER //
// ./src/frame/core/share.js